import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNumber } from '@iotv/datamodel-core';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Grid } from '@mui/material';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState } from 'react';
import { useTypedSearchParams } from '../../../hooks/useTypedSearchParams';
import { NetworkCoverageContext } from '../NetworkCoverageContext';
const debug = process.env.REACT_APP_DEBUG && false;
export const CoverageStepper = ({ steps, children }) => {
    const { state, dispatch } = useContext(NetworkCoverageContext);
    //const [wizardContext, setWizardContext] = useContext(WizardContext)
    const setActiveStep = (newStep) => {
        dispatch({ type: 'setWizardStep', step: newStep });
    };
    const { activeStep, allowBack, allowNext } = state;
    const [{ activeStep: devActiveStep }] = useTypedSearchParams();
    /** allow if params have active step */
    useEffect(() => {
        const step = devActiveStep && parseInt(devActiveStep);
        if (isNumber(step))
            setActiveStep(step);
    }, []);
    const [skipped, setSkipped] = useState(new Set());
    const isStepOptional = (step) => {
        return false;
    };
    const isStepSkipped = (step) => {
        return skipped.has(step);
    };
    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }
        setActiveStep(activeStep + 1);
        setSkipped(newSkipped);
    };
    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };
    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }
        setActiveStep(activeStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };
    const handleReset = () => {
        setActiveStep(0);
    };
    return (_jsx(Grid, { container: true, sx: { alignContent: 'center' }, children: _jsxs(Grid, { size: 12, children: [_jsx(Stepper, { activeStep, children: steps.map(({ label }, index) => {
                        const stepProps = { onClick: activeStep !== index ? () => setActiveStep(index) : undefined };
                        const labelProps = {};
                        if (isStepOptional(index)) {
                            labelProps.optional = _jsx(Typography, { variant: 'caption', children: "Optional" });
                        }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false;
                        }
                        return (_jsx(Step, { ...stepProps, children: _jsx(StepLabel, { ...labelProps, children: label }) }, label));
                    }) }), activeStep === steps.length ? (_jsx(Typography, { sx: { mt: 2, mb: 1 }, children: "All steps completed \u2014 you're finished" })) : (_jsx(Typography, { sx: { mt: 2, mb: 1, marginInline: 1 }, children: steps[activeStep].desc })), children, activeStep === steps.length ? (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'row', pt: 2 }, children: [_jsx(Box, { sx: { flex: '1 1 auto' } }), _jsx(Button, { variant: 'outlined', onClick: handleReset, children: "Reset" })] })) : (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'row', pt: 2 }, children: [0 < activeStep && _jsx(Button, { variant: 'contained', sx: { mr: 1 }, disabled: !allowBack, onClick: handleBack, children: "Back" }), _jsx(Box, { sx: { flex: '1 1 auto' } }), isStepOptional(activeStep) && _jsx(Button, { color: 'inherit', onClick: handleSkip, sx: { mr: 1 }, variant: 'contained', children: "Skip" }), _jsx(Button, { onClick: handleNext, variant: 'contained', disabled: !allowNext, children: activeStep === steps.length - 1 ? 'Finish' : 'Next' })] }))] }) }));
};
